import { axiosInstance } from "../../utils/axios";

export interface TenantPreferencesIcp {
  countries: string[];
  industries: string[];
  company_sizes: string[];
}

export interface TenantPreferencesAntiIcp {
  countries: string[];
  industries: string[];
  company_sizes: string[];
  others: string[];
}

export interface TenantPreferencesPersonaConfig {
  description: string;
  job_titles: string[];
  similar_titles?: boolean;
}

export interface TenantPreferences {
  icp: TenantPreferencesIcp;
  anti_icp: TenantPreferencesAntiIcp;
  key_website_pages: {
    demo_request: string[];
    pricing: string[];
    sign_up: string[];
  };
  personas: string[];
  persona_configs: Record<string, TenantPreferencesPersonaConfig>;
  products: string[];
  excluded_products: string[];
  competitors: string[];
  partner_integrations: string[];
  intent_topics: string[];
}

export async function fetchTenantPreferences(): Promise<TenantPreferences | null> {
  const response = await axiosInstance.get<TenantPreferences | null>(
    "/argo-api/tenant-preferences"
  );
  return response.data;
}
